import { TextModel } from '~/apis/search';
import { Typography } from '@bgzt/ui';

import styles from './EmptyResultGuide.module.css';

type Props = {
  guide?: TextModel[];
  isBlockedKeyword?: boolean;
};

export const EmptyResultGuide = ({ guide, isBlockedKeyword = false }: Props) => {
  if (!guide) return null;
  return (
    <ul className={styles.container}>
      {guide?.map((item, index) => {
        const attribute = item.main?.attribute;
        const isTitle = index === 0;
        return (
          <li key={index}>
            <Typography
              variant={attribute?.typography ?? 'C1'}
              color={isTitle && isBlockedKeyword ? 'red-500' : 'gray-600'}
              as={'p'}
            >
              {item.main?.text}
            </Typography>
          </li>
        );
      })}
    </ul>
  );
};
